import type { ProjectListResponsePageAllOfThreeContentItemUserInfoBasicInfo } from './projectListResponsePageAllOfThreeContentItemUserInfoBasicInfo';
import type { ProjectListResponsePageAllOfThreeContentItemUserInfoSocial } from './projectListResponsePageAllOfThreeContentItemUserInfoSocial';

/**
 * 간략한 사용자 정보
 */
export type ProjectListResponsePageAllOfThreeContentItemUserInfo = {
  /** 사용자 기본 정보 */
  basicInfo: ProjectListResponsePageAllOfThreeContentItemUserInfoBasicInfo;
  /** 소셜 관계 정보 */
  social?: ProjectListResponsePageAllOfThreeContentItemUserInfoSocial;
};
